module.exports = __webpack_public_path__ + "img/38312____.prt.1134aecc.jpg";